<template>
    <div class="container-toogle-transfer-reserves">
        <ui-card-toggle design="brightness" set-status :shadow="4" :open="true">
            <template #title>
                <div class="title-transfer-reserves">
                    <em class="fal fa-bug" />

                    <span>Ferramenta de Depuração</span>
                </div>
            </template>

            <template #content>
                <ui-load-success v-if="loader.overlay" :loading="loader.overlayLoading" :success="loader.overlaySucess"/>

                <div class="area-card">
                    <transition v-if="loader.body" name="small-fade">
                        <div class="loading-card">
                            <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8"/>
                        </div>
                    </transition>

                    <template v-else>
                        <div v-for="(field, index) in form.field"  :key="index" class="container-fields" >
                            <span class="title-fields">
                                {{ field.label }}
                            </span>
	
                            <div v-for="(fields, index) in field.options" :key="index" class="container-switch" >
                                <span>{{ fields.label }}</span>

                                <ui-switch
                                    v-model="fields.active"
                                    design="xs"
                                    :checked="fields.active"
                                    :disabled="userLogged.user_group != 'admin'"
                                />
                            </div>
                        </div>
                    </template>
                </div>

                <div class="footer-card">
                    <ui-button design="md success" :disabled="!canSubmit" @click="submit">
                        Salvar
                    </ui-button>
                </div>
            </template>
        </ui-card-toggle>
    </div>
</template>

<script>
import { uiLoadIndicator } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import { uiCardToggle } from '@/components/ui/cards'
import { uiSwitch } from '@/components/ui/form'
import { uiLoadSuccess } from '@/components/ui/overlays'

import { alertMixin, formMixin } from '@/mixins'
import { storage } from '@/services/storage'

import { integration } from '@/services/axios'

const defaultForm = () => ({
	field: [
		{
			label: 'Ativar Modo Debugger',
			options: [
				{
					type: 'debug-mode',
					active: false,
					label: 'Habilita o rastreamento de erros no envio de propostas ao ERP',
				},
			],
		},
	],
})

const defaultLoader = () => ({
	body: false,
	overlay: false,
	overlayLoading: true,
	overlaySucess: true,
})

export default {
	name: 'toogle-debug-mode',

	components: {
		uiButton,
		uiLoadSuccess,
		uiLoadIndicator,
		uiSwitch,
		uiCardToggle,
	},

	mixins: [formMixin, alertMixin],

	data() {
		return {
			form: { ...defaultForm() },
			loader: { ...defaultLoader() },
			oldForm: {},
			userLogged: JSON.parse(storage.get('user_logged')),
		}
	},

	computed: {
		canSubmit() {
			return this.$mx_isFormChanged && !this.loader.body
		},
	},

	async created() {
		this.loader.body = true
		await this.load(), this.$mx_copyOldForm()
	},

	methods: {
		async load() {
			this.loader.body = true
			try {
				const response = await integration.getV2('erp/configurations/debug-mode-proposal', '')

				if (response?.data?.status === 'success') {
					this.form.field[0].options = [{...this.form.field[0].options[0],
            active: response.data.active
          }]
        }
				this.loader.body = false
			} catch (error) {
				if (error.data?.msg) {
					this.$mx_alertError(error.data.msg)
				} else {
					this.$mx_alertError(error)
				}
				this.loader.body = false
			} finally {
				this.loader.body = false
			}
		},

		async submit() {
      const debuggerActive = this.form.field[0].options[0].active

			this.loader.overlay = true
			this.loader.overlayLoading = true

			try {
				let response = await integration.updateProposalDebugger(debuggerActive)
				this.$mx_alertSuccess(response?.data?.msg)
                
				setTimeout(() => {
					this.loader.overlayLoading = false
					this.loader.overlaySucess = true
					setTimeout(() => {
						this.loader.overlay = false
					}, 500)
				}, 500)

				this.$mx_copyOldForm()
			} catch (error) {
				if (error.data?.msg) {
					this.$mx_alertError(error.data.msg)
				} else {
					this.$mx_alertError(error)
				}
			} finally {
				this.loader.overlaySucess = false
				setTimeout(() => {
					this.loader.overlay = false
				}, 1000)
			}
		},
	},
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
